"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Identifier = void 0;
const object_1 = require("@groupby/stdlib-core/object");
const field_1 = require("../../field");
const expression_precedence_1 = require("../expression-precedence");
const expression_node_1 = require("../nodes/expression-node");
const types_1 = require("../types");
class Identifier extends expression_node_1.ExpressionNode {
    constructor(field) {
        super();
        this[Symbol.toStringTag] = 'Identifier';
        this.children = [];
        this.precedence = expression_precedence_1.ExpressionPrecedence.Expression;
        this.type = types_1.ExpressionType.Unknown;
        this.field = field;
    }
    // eslint-disable-next-line @typescript-eslint/ban-types
    evaluate(operand) {
        return object_1.dig(operand, this.field.name);
    }
    format() {
        return this.field.name;
    }
    clone() {
        return new Identifier(new field_1.Field(this.field.name));
    }
    accept(visitor) {
        visitor.visitIdentifier(this);
    }
}
exports.Identifier = Identifier;
//# sourceMappingURL=identifier.js.map